<template>
    <div class="more-btn">
        <div class=hover>
            <!-- 悬浮的按钮 -->
            <slot name="hoverBtn"></slot>
        </div>
        <div class=dropdown>
            <!-- 下拉框 -->
            <div class=default-dropdown>
                <div class=row>
                    <span style='width:80px;'>路由器备注：</span>
                    <span v-text="tag.linkSpeed"></span>
                </div>
                <div class=row>
                    <span v-html="tag.remark"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'hoverdownleft',
    props: {
        tag: {
            type: Object
        }
    }
}
</script>

<style lang="scss" scoped>
.more-btn {
    display: inline-block;
    position: relative;
    height: 0px;
    margin-left: 6px;
    z-index: 4;
    .hover {
        cursor: pointer;
    }
    &:hover {
        z-index: 5;
        .dropdown {
            opacity: 1;
            visibility: visible;
            z-index: 5;
            .default-dropdown {
                // top: 0px;
            }
        }
    }
    .dropdown {
        position: absolute;
        left: -10px;
        top: 22px;
        padding: 10px;
        visibility: hidden;
        overflow: hidden;
        min-width: 200px;
        transition: all .2s;
        opacity: 0;
        .default-dropdown {
            // top: -220px;
            top:8px;
            left: 0px;
            min-width: 160px;
            padding: 10px;
            .row{
                line-height: normal;
            }
            span {
                display: inline-block;
                line-height: 18px;
            }
        }
    }
}
</style>
